module.exports = __webpack_public_path__ + "static/img/nab-icon.5d76d2a0.gif";